import { render, staticRenderFns } from "./RestoreForm.vue?vue&type=template&id=19c0bb8a"
import script from "./RestoreForm.vue?vue&type=script&lang=js"
export * from "./RestoreForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c0bb8a')) {
      api.createRecord('19c0bb8a', component.options)
    } else {
      api.reload('19c0bb8a', component.options)
    }
    module.hot.accept("./RestoreForm.vue?vue&type=template&id=19c0bb8a", function () {
      api.rerender('19c0bb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/RestoreForm.vue"
export default component.exports